import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private authService = inject(AuthService);
  private sharedService = inject(SharedService);

  InitializeLoginState(): void {
    this.authService.UpdateLoggedInStatus();
  }

  Login(): void {
    if (this.authService.loggedIn) {
      this.sharedService.NavigateToProjectList();
      return;
    }

    this.authService.Login();
  }
}
